// var productCardMarkup = `<div class="swym-wishlist-grid product-grid product-grid--one-third">
//    {{#products}} 
//    <div class="product-grid__item product-grid__item--one-third">
// 		<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
// 			<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
// 			<span class="swym-icon">
// 			</span>
// 			</button>
// 			<div class="swym-wishlist-image-wrapper">
// 			<img alt="" class="swym-wishlist-image" src="{{iu}}">
// 			</div>
// 			<button class="swym-is-button">
// 			<div class="swym-title swym-title-1">
// 				{{dt}}
// 			</div>
// 			</button>
// 			<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
// 			{{variantinfo}}
// 			</div>
// 			<div class="swym-product-price swym-text swym-text-1">
// 			<div class="swym-product-final-price swym-value">
// 				{{cu}}{{pr}}
// 			</div>
// 			</div>
// 			<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
// 			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
// 			</button>
// 		</a>
// 	</div>
//    {{/products}}
// </div>`;

var productCardMarkup = `<div class="product-grid product-grid--fifth product-grid-wishlist">
   {{#products}} 
   <div class="product-grid__item product-grid__item--fifth p-2">
		<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor !block">
			<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button !bg-loading !w-[28px] !h-[28px]">
				<!-- <span class="swym-icon"></span> -->
				<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-trash fill-secondary"  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V4.66667H3.99992V12.6667ZM5.33325 6H10.6666V12.6667H5.33325V6ZM10.3333 2.66667L9.66659 2H6.33325L5.66659 2.66667H3.33325V4H12.6666V2.66667H10.3333Z" />
				</svg>
			</button>
			<div class="swym-wishlist-image-wrapper aspect-square">
				<img alt="{{dt}}" class="swym-wishlist-image object-contain w-full h-full" src="{{iu}}">
			</div>
			<div class="mt-1 text-sm leading-4 font-bold tracking-[-0.01em] uppercase">
				<div>
					<span>{{cu}}{{pr}}</span>
				</div>
			</div>
			<a href="{{du}}" class="text-sm leading-4 overflow-hidden whitespace-nowrap block text-ellipsis" title="{{dt}}">
				{{dt}}
			</a>
			<div class="text-xs text-disabled-text uppercase mt-1">
				{{variantinfo}}
			</div>
			<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn py-2 px-2 w-full leading-none mt-2">
				{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
			</button>
		</a>
	</div>
   {{/products}}
</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);

		// Dispatch addtocart event
		let event = new CustomEvent("addtocart", {});
        window.dispatchEvent(event);	

	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
	});
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */